import * as lodash from 'lodash';
import { removeNulls } from 'utils';
export const constructorForTreeComponent = (arr, setResult) => {
    const arrGroupOldOrNew = arr.reduce((newA, elem) => {
        const patternForSettings = (settings, iD, flag) => {
            if (flag) {
                return [{ settings: settings, id: iD }];
            }
            else {
                if (lodash.isPlainObject(settings)) {
                    return Object.keys(settings).map((i, index) => ({
                        settings: { [i]: settings[i] },
                        id: `${iD}${index++}`,
                    }));
                }
                else {
                    return { settings: settings, id: iD };
                }
            }
        };
        const pattern = (type) => {
            if (elem[type] !== 'нет') {
                return {
                    key: elem.key,
                    el: {
                        setter: patternForSettings(elem[type], elem.id, elem?.flag),
                        ...(elem.name && elem.name[type] && { name: elem.name[type] }),
                        ...(elem.flag && { flag: elem.flag }),
                        ...(elem.idSensor && { idSensor: elem.idSensor }),
                    },
                };
            }
            else {
                return null;
            }
        };
        return {
            ...newA,
            new: lodash.uniqWith(
            // uniqWith удаляем элементы с одинаковыми id
            removeNulls(newA.new ? [...newA.new, pattern('new')] : [pattern('new')]), function (arrVal, othVal) {
                if (arrVal.el.idSensor) {
                    return arrVal.el.idSensor === othVal.el.idSensor;
                }
                else
                    return false;
            }),
            old: removeNulls(newA.old ? [...newA.old, pattern('old')] : [pattern('old')]),
        };
    }, {});
    const groupKey = (type) => {
        return lodash.groupBy(arrGroupOldOrNew[type], 'key');
    };
    const arResultOld = Object.keys(groupKey('old')).reduce((acc, key) => {
        return [...acc, { key: key, el: groupKey('old')[key].map((i) => i.el) }];
    }, []);
    const arResultNew = Object.keys(groupKey('new')).reduce((acc, key) => {
        return [...acc, { key: key, el: groupKey('new')[key].map((i) => i.el) }];
    }, []);
    return setResult({ new: arResultNew, old: arResultOld });
};
